export default {
  collections: null,
  collectionDetail: null
}
